webpackJsonp([121727861784466],{

/***/ 1068:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.emailStyle = exports.leftSideStyle = exports.formSubmitStyle = exports.formTitleStyle = exports.contactTitleStyle = exports.bodyStyle = exports.innerWrapperStyle = exports.metaStyle = exports.locationStyle = exports.subTitleStyle = exports.titleStyle = exports.innerStyleOrganisation = undefined;
	
	var _css;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var innerStyleOrganisation = /*#__PURE__*/exports.innerStyleOrganisation = (0, _emotion.css)({
		'& img': {
			display: 'block',
			maxWidth: '255px'
		}
	});
	
	var titleStyle = exports.titleStyle = (0, _emotion.cx)(_globalStyles.headingXLarge, /*#__PURE__*/(0, _emotion.css)({
		fontSize: '36px',
		lineHeight: '42px',
		margin: '0 0 54px 0'
	}));
	
	var subTitleStyle = exports.subTitleStyle = (0, _emotion.cx)(_globalStyles.headingSmall, /*#__PURE__*/(0, _emotion.css)({
		margin: '0 0 13px 0'
	}));
	
	var locationStyle = /*#__PURE__*/exports.locationStyle = (0, _emotion.css)({
		color: _globalStyles.grey,
		fontWeight: 300,
		fontSize: '18px',
		lineHeight: '20px',
		marginTop: 0,
		marginBottom: '18px'
	});
	
	var metaStyle = exports.metaStyle = (0, _emotion.cx)(_globalStyles.metaTable, /*#__PURE__*/(0, _emotion.css)({
		marginBottom: '40px'
	}));
	
	var innerWrapperStyle = /*#__PURE__*/exports.innerWrapperStyle = (0, _emotion.css)({
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '0 auto',
		position: 'relative'
	});
	
	var bodyStyle = exports.bodyStyle = (0, _emotion.cx)(_globalStyles.textBlockLarger, /*#__PURE__*/(0, _emotion.css)((_css = {
		marginBottom: '40px'
	}, _css['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		fontSize: '14px'
	}, _css)));
	
	var contactTitleStyle = exports.contactTitleStyle = (0, _emotion.cx)(_globalStyles.headingLarge, /*#__PURE__*/(0, _emotion.css)({
		margin: '0 0 20px 0'
	}));
	
	var formTitleStyle = exports.formTitleStyle = (0, _emotion.cx)(_globalStyles.headingSmall, /*#__PURE__*/(0, _emotion.css)({
		margin: '0 0 24px 0'
	}));
	
	var formSubmitStyle = exports.formSubmitStyle = (0, _emotion.cx)(_globalStyles.formSection.submitButton, /*#__PURE__*/(0, _emotion.css)({
		marginTop: '60px'
	}));
	
	var leftSideStyle = exports.leftSideStyle = (0, _emotion.cx)(_globalStyles.detailSideBarLayout.leftSide, /*#__PURE__*/(0, _emotion.css)({
		width: '832px'
	}));
	
	var emailStyle = /*#__PURE__*/exports.emailStyle = (0, _emotion.css)({
		textDecoration: 'none'
	});

/***/ }),

/***/ 1153:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pragmaticForms = __webpack_require__(60);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _fileAttachments = __webpack_require__(375);
	
	var _link = __webpack_require__(9);
	
	var _formManager = __webpack_require__(106);
	
	var _headerManager = __webpack_require__(31);
	
	var _dateManager = __webpack_require__(62);
	
	var _detail = __webpack_require__(1068);
	
	var _globalStyles = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Gatsby requires a specific export format on Templates.
	var ResearchProjectDetail = function (_React$PureComponent) {
		_inherits(ResearchProjectDetail, _React$PureComponent);
	
		function ResearchProjectDetail() {
			var _this2 = this;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ResearchProjectDetail);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
				hasSubmitted: false
			}, _this.ApplyNowForm = (0, _pragmaticForms.configureForm)({
				initFields: function initFields() {
					return {
						'form-name': 'apply-research-trial',
						botField: '',
						firstName: '',
						lastName: '',
						email: '',
						phoneNumberPrefix: '',
						phoneNumber: ''
					};
				},
				validate: function validate(_ref) {
					var firstName = _ref.firstName,
					    lastName = _ref.lastName,
					    email = _ref.email,
					    phoneNumberPrefix = _ref.phoneNumberPrefix,
					    phoneNumber = _ref.phoneNumber;
	
					var errors = {};
	
					if (!firstName) errors.firstName = 'Please enter your First Name';
					if (!lastName) errors.lastName = 'Please enter your Last Name';
					if (!email) errors.email = 'Please enter an Email Address';
					if (!phoneNumberPrefix) errors.phoneNumberPrefix = 'Please enter a phone prefix';
					if (!phoneNumber) errors.phoneNumber = 'Please enter a phone number';
	
					return errors;
				},
				submit: function () {
					var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(formData) {
						return regeneratorRuntime.wrap(function _callee$(_context) {
							while (1) {
								switch (_context.prev = _context.next) {
									case 0:
										_context.prev = 0;
										_context.next = 3;
										return fetch('/', {
											method: 'POST',
											body: (0, _formManager.encode)(formData)
										});
	
									case 3:
	
										_this.setState({ hasSubmitted: true });
										_context.next = 9;
										break;
	
									case 6:
										_context.prev = 6;
										_context.t0 = _context['catch'](0);
	
										console.error(_context.t0);
	
									case 9:
									case 'end':
										return _context.stop();
								}
							}
						}, _callee, _this2, [[0, 6]]);
					}));
	
					return function submit(_x) {
						return _ref2.apply(this, arguments);
					};
				}()
			})(function (_ref3) {
				var form = _ref3.form;
				return _react2.default.createElement(
					form.Form,
					{ netlify: 'true', name: 'apply-research-trial', 'netlify-honeypot': 'botField' },
					_react2.default.createElement(
						'div',
						{ className: _globalStyles.formSection.wrapper },
						_react2.default.createElement(
							'p',
							{ style: { display: 'none' } },
							_react2.default.createElement(
								'label',
								null,
								'Don\u2019t fill this out if you\'re human:',
								_react2.default.createElement('input', form.getInputProps({ name: 'botField', type: 'text' }))
							)
						),
						_react2.default.createElement(
							'h1',
							{ className: _detail.formTitleStyle },
							'Apply now'
						),
						_react2.default.createElement(
							'div',
							{ 'aria-live': 'assertive' },
							form.submitError && _react2.default.createElement(
								'p',
								{ className: _globalStyles.formSection.validationMessage },
								'Error: ',
								form.submitError
							),
							form.hasErrors && _react2.default.createElement(
								'ul',
								{ className: _globalStyles.formSection.validationSummary },
								Object.keys(form.errors).map(function (key) {
									return _react2.default.createElement(
										'li',
										{ key: key, className: _globalStyles.formSection.validationMessage },
										'' + form.errors[key]
									);
								})
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _globalStyles.formSection.halfWidthWrapper },
							_react2.default.createElement(
								'div',
								{ className: _globalStyles.formSection.field },
								form.errors['firstName'] && _react2.default.createElement(
									'p',
									{ className: _globalStyles.formSection.validationFieldMessage },
									form.errors['firstName']
								),
								_react2.default.createElement(
									'label',
									{ htmlFor: 'firstName' },
									'First Name'
								),
								_react2.default.createElement('input', _extends({ id: 'firstName' }, form.getInputProps({ name: 'firstName', type: 'text' })))
							),
							_react2.default.createElement(
								'div',
								{ className: _globalStyles.formSection.field },
								form.errors['lastName'] && _react2.default.createElement(
									'p',
									{ className: _globalStyles.formSection.validationFieldMessage },
									form.errors['lastName']
								),
								_react2.default.createElement(
									'label',
									{ htmlFor: 'lastName' },
									'Last Name'
								),
								_react2.default.createElement('input', _extends({ id: 'lastName' }, form.getInputProps({ name: 'lastName', type: 'text' })))
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _globalStyles.formSection.field },
							form.errors['email'] && _react2.default.createElement(
								'p',
								{ className: _globalStyles.formSection.validationFieldMessage },
								form.errors['email']
							),
							_react2.default.createElement(
								'label',
								{ htmlFor: 'email' },
								'Email Address'
							),
							_react2.default.createElement('input', _extends({ id: 'email' }, form.getInputProps({ name: 'email', type: 'text' })))
						),
						_react2.default.createElement(
							'div',
							{ className: _globalStyles.formSection.phoneField },
							form.errors['phoneNumberPrefix'] && _react2.default.createElement(
								'p',
								{ className: _globalStyles.formSection.validationFieldMessage },
								form.errors['phoneNumberPrefix']
							),
							form.errors['phoneNumber'] && _react2.default.createElement(
								'p',
								{ className: _globalStyles.formSection.validationFieldMessage },
								form.errors['phoneNumber']
							),
							_react2.default.createElement(
								'label',
								{ htmlFor: 'phoneNumberPrefix' },
								'Phone Number'
							),
							_react2.default.createElement(
								'select',
								_extends({
									id: 'phoneNumberPrefix',
									name: 'phoneNumberPrefix'
								}, form.getInputProps({ name: 'phoneNumberPrefix', type: 'text' })),
								_react2.default.createElement(
									'option',
									{ value: '+61' },
									'+61'
								)
							),
							_react2.default.createElement('input', _extends({ id: 'phoneNumber' }, form.getInputProps({ name: 'phoneNumber', type: 'text' })))
						),
						_react2.default.createElement(
							'button',
							{
								className: _detail.formSubmitStyle,
								type: 'submit',
								disabled: form.hasErrors || form.isLoading
							},
							'Apply Now'
						)
					)
				);
			}), _this.componentDidMount = function () {
				_headerManager.HeaderManager.headerProperties = {};
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		ResearchProjectDetail.prototype.render = function render() {
			var node = this.props.data.researchTrial.edges[0].node;
	
	
			return _react2.default.createElement(
				'section',
				null,
				_react2.default.createElement(
					_reactHelmet.Helmet,
					{ title: node.title },
					_react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
					_react2.default.createElement('meta', { property: 'og:title', content: node.title })
				),
				_react2.default.createElement(
					'div',
					{ className: _detail.innerWrapperStyle },
					_react2.default.createElement(
						'div',
						{ className: _globalStyles.detailSideBarLayout.wrapper },
						_react2.default.createElement(
							'div',
							{ className: _detail.leftSideStyle },
							_react2.default.createElement(
								'div',
								{ className: (0, _globalStyles.contentSection)('#fff') },
								_react2.default.createElement(
									'p',
									{ className: _detail.locationStyle },
									node.academic_institution
								),
								_react2.default.createElement(
									'h1',
									{ className: _detail.titleStyle },
									node.title
								),
								_react2.default.createElement(
									'div',
									{ className: _detail.metaStyle },
									_react2.default.createElement(
										'table',
										null,
										_react2.default.createElement(
											'tbody',
											null,
											_react2.default.createElement(
												'tr',
												null,
												node.chief_investigator && _react2.default.createElement(
													'th',
													null,
													_react2.default.createElement(
														'span',
														null,
														'Chief Investigator'
													)
												),
												node.university_supervisor && _react2.default.createElement(
													'th',
													null,
													_react2.default.createElement(
														'span',
														null,
														'University Supervisor'
													)
												),
												node.recruitment_close_date && _react2.default.createElement(
													'th',
													null,
													_react2.default.createElement(
														'span',
														null,
														'Closing Date'
													)
												)
											),
											_react2.default.createElement(
												'tr',
												null,
												node.chief_investigator && _react2.default.createElement(
													'td',
													null,
													_react2.default.createElement(
														'span',
														null,
														node.chief_investigator
													)
												),
												node.university_supervisor && _react2.default.createElement(
													'td',
													null,
													_react2.default.createElement(
														'span',
														null,
														node.university_supervisor
													)
												),
												node.recruitment_close_date && _react2.default.createElement(
													'td',
													null,
													_react2.default.createElement(
														'span',
														null,
														(0, _dateManager.format)(node.recruitment_close_date)
													)
												)
											)
										)
									),
									_react2.default.createElement(
										'table',
										null,
										_react2.default.createElement(
											'tbody',
											null,
											node.chief_investigator && _react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'th',
													null,
													_react2.default.createElement(
														'span',
														null,
														'Chief Investigator'
													)
												),
												_react2.default.createElement(
													'td',
													null,
													_react2.default.createElement(
														'span',
														null,
														node.chief_investigator
													)
												)
											),
											node.university_supervisor && _react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'th',
													null,
													_react2.default.createElement(
														'span',
														null,
														'University Supervisor'
													)
												),
												_react2.default.createElement(
													'td',
													null,
													_react2.default.createElement(
														'span',
														null,
														node.university_supervisor
													)
												)
											),
											node.recruitment_close_date && _react2.default.createElement(
												'tr',
												null,
												_react2.default.createElement(
													'th',
													null,
													_react2.default.createElement(
														'span',
														null,
														'Closing Date'
													)
												),
												_react2.default.createElement(
													'td',
													null,
													_react2.default.createElement(
														'span',
														null,
														(0, _dateManager.format)(node.recruitment_close_date)
													)
												)
											)
										)
									)
								),
								_react2.default.createElement(
									'h2',
									{ className: _detail.subTitleStyle },
									'About the research trial'
								),
								_react2.default.createElement('div', {
									className: _detail.bodyStyle,
									dangerouslySetInnerHTML: { __html: node.project_description }
								}),
								_react2.default.createElement(
									'h2',
									{ className: _detail.subTitleStyle },
									'Recruitment details'
								),
								_react2.default.createElement('div', {
									className: _detail.bodyStyle,
									dangerouslySetInnerHTML: { __html: node.recruitment_details }
								}),
								_react2.default.createElement(_fileAttachments.FileAttachments, { title: 'Attachments', attachments: node.attachments })
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: (0, _globalStyles.contentSection)() },
					_react2.default.createElement(
						'div',
						{ className: _detail.innerWrapperStyle },
						_react2.default.createElement(
							'div',
							{ className: _globalStyles.detailSideBarLayout.wrapper },
							_react2.default.createElement(
								'div',
								{ className: _globalStyles.detailSideBarLayout.leftSide },
								_react2.default.createElement(
									'h2',
									{ className: _detail.contactTitleStyle },
									node.contact_first_name,
									' ',
									node.contact_last_name
								),
								_react2.default.createElement(
									'ul',
									{ className: _globalStyles.contactList.wrapper },
									node.contact_phone && _react2.default.createElement(
										'li',
										{ className: _globalStyles.contactList.item('phone-number') },
										node.contact_phone
									),
									node.contact_email && _react2.default.createElement(
										'li',
										{ className: _globalStyles.contactList.item('email') },
										_react2.default.createElement(
											_link.Link,
											{ href: 'mailto:' + node.contact_email },
											node.contact_email
										)
									),
									node.contact_website && _react2.default.createElement(
										'li',
										{ className: 'fullWidth' },
										_react2.default.createElement(
											_link.Link,
											{
												className: _globalStyles.formSection.submitButton,
												href: node.contact_website.indexOf('://') === -1 ? 'http://' + node.contact_website : node.contact_website
											},
											'Go to website'
										)
									)
								)
							)
						)
					)
				),
				node.type === 'InsideOut' && _react2.default.createElement(
					'div',
					{ className: (0, _globalStyles.contentSection)('#fff') },
					_react2.default.createElement(
						'div',
						{ className: _detail.innerWrapperStyle },
						_react2.default.createElement(
							'div',
							{ className: _globalStyles.detailSideBarLayout.wrapper },
							_react2.default.createElement(
								'div',
								{ className: _globalStyles.detailSideBarLayout.leftSide },
								!this.state.hasSubmitted && _react2.default.createElement(this.ApplyNowForm, null),
								this.state.hasSubmitted && _react2.default.createElement(
									_react2.default.Fragment,
									null,
									_react2.default.createElement(
										'p',
										{ className: _detail.titleStyle },
										'Thank you.'
									)
								)
							)
						)
					)
				)
			);
		};
	
		return ResearchProjectDetail;
	}(_react2.default.PureComponent);
	
	ResearchProjectDetail.propTypes = {
		data: _propTypes2.default.shape({
			researchTrial: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						academic_institution: _propTypes2.default.string,
						title: _propTypes2.default.string,
						chief_investigator: _propTypes2.default.string,
						university_supervisor: _propTypes2.default.string,
						recruitment_close_date: _propTypes2.default.string,
						project_description: _propTypes2.default.string,
						recruitment_details: _propTypes2.default.string,
						attachments: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							file: _propTypes2.default.string
						})),
						contact_first_name: _propTypes2.default.string,
						contact_last_name: _propTypes2.default.string,
						contact_phone_country_code: _propTypes2.default.string,
						contact_phone: _propTypes2.default.string,
						contact_email: _propTypes2.default.string,
						contact_website: _propTypes2.default.string
					})
				}))
			})
		})
	};
	exports.default = ResearchProjectDetail;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-research-trials-detail-index-js-0abc3654a1f1904eeb2e.js